export function csrfHeaders() {
  const csrfToken = document.cookie
    .split("; ")
    .find((cookie) => cookie.startsWith("csrf_token="))
    ?.split("=")
    .slice(1)
    .join("=");
  return csrfToken ? { "X-CSRF-Token": decodeURIComponent(csrfToken) } : {};
}